import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { Image } from 'app/components/image';
import { breakpointTablet } from 'app/style/breakpoints';
import { colorSecondary200 } from 'app/style/colors';
import { spacing0, spacing1, spacing2, spacing3, spacing5 } from 'app/style/spacing';

export const StyledContainer = styled.div`
    display: flex;
    padding: ${spacing3} 0;

    &:not(:last-child) {
        border-bottom: 1px solid ${colorSecondary200};
    }

    &:first-child {
        padding-top: 0;
    }

    &:last-child {
        padding-bottom: 0;
    }

    @media (min-width: ${breakpointTablet}) {
        padding: ${spacing5} 0;

        &:first-child {
            padding-top: ${spacing2};
        }
    }
`;

export const StyledImage = styled(Image)`
    display: none;

    @media (min-width: ${breakpointTablet}) {
        max-width: 70px;
        margin-right: ${spacing3};
        align-self: center;
        display: block;
        flex-shrink: 0;
        object-fit: contain;
    }
`;

export const StyledProductInformation = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
`;

export const StyledProductTitle = styled(Typography)`
    padding-bottom: ${spacing0};
    margin-right: ${spacing2};
`;

export const StyledPriceContainer = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &:not(:first-child) {
        margin-top: ${spacing1};
    }
`;

export const StyledValue = styled(Typography)`
    margin-left: auto;
`;

export const StyledQuantityRow = styled.div`
    display: flex;
    margin-right: ${spacing2};
`;

export const StyledQuantity = styled(Typography)`
    padding-left: ${spacing1};
`;
